import React from 'react';

import { Dropdown } from 'primereact/dropdown';
import { asyncSelectCustomStyles } from "../../util/styles";
import { reactSelectIcons } from "../../util/reactSelectPrimeIcons";

import AsyncSelect from "react-select/async";
import DatePicker from "react-datepicker";
import axios from 'axios';

import './Style.css';

class PainelFiltros extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            buildingSuggestions: [],
            buildingAllSelected: false,
            userSuggestions: [],
            incorporatorSuggestions: [],
            incorporatorAllSelected: false,
        };

        this.searchTimeouts = {
            building: null,
            user: null,
            incorporator: null,
        };
    }

    debounce = (key, callback, delay = 250) => {
        clearTimeout(this.searchTimeouts[key]);

        this.searchTimeouts[key] = setTimeout(() => {
            callback();
        }, delay);
    };

    isSelectAllOption = (option) => {
        return option?.id === 'Selecionar Todos';
    };

    removeSelectAllOption = (options) => {
        return (options || []).filter(
            (option) => !this.isSelectAllOption(option)
        );
    };

    searchBuildings = async (inputValue) => {
        if (this.state.buildingAllSelected) {
            return this.state.buildingSuggestions;
        }

        if (!inputValue || inputValue.length < 3) {
            return this.state.buildingSuggestions;
        }

        try {
            const response = await axios.get(
                `/autocomplete/${this.props.cityPeriod.city_id}`,
                {
                    params: {
                        search: inputValue,
                    },
                }
            );

            const suggestions = response.data || [];

            this.setState({
                buildingSuggestions: suggestions,
            });

            return this.getAvailableSuggestions(suggestions, this.props.filters?.name);
        } catch (error) {
            console.error('Erro ao buscar empreendimentos:', error);
            return [];
        }
    };

    getBuildingDefaultOptions = () => {
        const selectedOptions = this.props.filters?.name || [];
        return this.getAvailableSuggestions(this.state.buildingSuggestions, selectedOptions);
    };

    handleBuildingChange = (selectedOptions) => {
        const selected = selectedOptions || [];

        const selectedAll = selected.some(
            (option) => this.isSelectAllOption(option)
        );

        if (selectedAll) {
            const allOptions = this.removeSelectAllOption(this.state.buildingSuggestions);

            this.setState({
                buildingAllSelected: true,
            });

            this.props.onFilterChange('name', allOptions);

            return;
        }

        this.setState({
            buildingAllSelected: false,
        });

        this.props.onFilterChange('name', selected);
    };

    searchUsers = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            const response = await axios.get(
                '/autocomplete-users',
                {
                    params: {
                        search: inputValue,
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Erro ao buscar usuários:', error);
            return [];
        }
    };

    searchIncorporators = async (inputValue) => {
        if (this.state.incorporatorAllSelected) {
            return this.state.incorporatorSuggestions;
        }

        if (!inputValue || inputValue.length < 3) {
            return this.state.incorporatorSuggestions;
        }

        try {
            const response = await axios.get(
                '/autocomplete-incorporator-new',
                {
                    params: {
                        search: inputValue,
                    },
                }
            );

            const suggestions = response.data || [];

            this.setState({
                incorporatorSuggestions: suggestions,
            });

            return this.getAvailableSuggestions(suggestions, this.props.filters?.incorporator);
        } catch (error) {
            console.error('Erro ao buscar incorporadoras:', error);
            return [];
        }
    };

    getIncorporatorDefaultOptions = () => {
        const selectedOptions = this.props.filters?.incorporator || [];
        return this.getAvailableSuggestions(this.state.incorporatorSuggestions, selectedOptions);
    };

    handleIncorporatorChange = (selectedOptions) => {
        const selected = selectedOptions || [];

        const selectedAll = selected.some(
            (option) => this.isSelectAllOption(option)
        );

        if (selectedAll) {
            const allOptions = this.removeSelectAllOption(this.state.incorporatorSuggestions);

            this.setState({
                incorporatorAllSelected: true,
            });

            this.props.onFilterChange('incorporator', allOptions);

            return;
        }

        this.setState({
            incorporatorAllSelected: false,
        });

        this.props.onFilterChange('incorporator', selected);
    };

    getAvailableSuggestions = (suggestions, selectedOptions) => {
        const realSuggestions = this.removeSelectAllOption(suggestions);

        const selectedIds = new Set(
            (selectedOptions || []).map(
                (option) => String(option.id)
            )
        );

        const availableOptions = realSuggestions.filter(
            (option) => !selectedIds.has(String(option.id))
        );

        if (availableOptions.length === 0) {
            return [];
        }

        return [
            {
                id: 'Selecionar Todos',
                text: 'Selecionar Todos',
            },
            ...availableOptions,
        ];
    };

    componentWillUnmount() {
        Object.values(this.searchTimeouts).forEach(
            (timeout) => clearTimeout(timeout)
        );
    }

    render() {
        const {
            filters,
            bairros,
            padroes,
            cityPeriod,
            onFilterChange,
            onSubmit,
            onClear,
            selectedBases,
            onShowBulkActions,
        } = this.props;

        this.status = [
            {
                value: "Ativo",
                label: "Ativo",
            },
            {
                value: "Esgotado",
                label: "Esgotado",
            },
            {
                value: "Futuro",
                label: "Futuro",
            },
            {
                value: "Suspenso",
                label: "Suspenso",
            },
            {
                value: "Cooperativa",
                label: "Cooperativa",
            },
            {
                value: "Lançado",
                label: "Lançado",
            },
            {
                value: "Refutado",
                label: "Refutado",
            },
        ];

        this.tipos = [
            {
                value: "Vertical",
                label: "Vertical",
            },
            {
                value: "Horizontal",
                label: "Horizontal",
            },
            {
                value: "Comercial",
                label: "Comercial",
            },
            {
                value: "Hotel",
                label: "Hotel",
            },
        ];

        this.previsaoLancamento = [
            {
                value: "true",
                label: "Sim",
            },
            {
                value: "false",
                label: "Não",
            },
        ];

        this.atualizacoes = [
            {
                value: "Concluído",
                label: "Concluído",
            },
            {
                value: "Pendente",
                label: "Pendente",
            },
            {
                value: "Em andamento",
                label: "Em andamento",
            },
        ];

        this.perfis = [
            {
                value: "Operador",
                label: "Operador",
            },
            {
                value: "Parceiro",
                label: "Parceiro",
            },
        ];

        return (
            <form className="" onSubmit={onSubmit}>
                <div className='row'>
                    <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12 col-12">
                        <div className="formulario">
                            <div className="row">
                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12">
                                    <div className="form-group">
                                        <label>Empreendimento</label>
                                        <AsyncSelect
                                            isMulti
                                            isSearchable={ !this.state.buildingAllSelected }
                                            closeMenuOnSelect={ false }
                                            value={ filters.name }
                                            defaultOptions={ this.getBuildingDefaultOptions }
                                            loadOptions={ this.searchBuildings }
                                            getOptionLabel={(option) => option.text}
                                            getOptionValue={(option) => String(option.id)}
                                            onChange={ this.handleBuildingChange }
                                            styles={ asyncSelectCustomStyles }
                                            className="autocomplete"
                                            placeholder="Buscar"
                                            components={ reactSelectIcons }
                                            noOptionsMessage={() => "Digite para buscar..."}
                                            loadingMessage={() => 'Carregando...'}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Tipo</label>
                                        <Dropdown
                                            value={ filters.type }
                                            options={ this.tipos }
                                            placeholder="Selecione"
                                            className="dropdown"
                                            showClear
                                            optionLabel="label"
                                            optionValue='value'
                                            onChange={(event) =>
                                                onFilterChange('type', event.value)
                                            }
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Status</label>
                                        <Dropdown
                                            value={ filters.status }
                                            options={ this.status }
                                            placeholder="Selecione"
                                            className="dropdown"
                                            showClear
                                            optionLabel="label"
                                            optionValue='value'
                                            onChange={(event) =>
                                                onFilterChange('status', event.value)
                                            }
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Padrão</label>
                                        <Dropdown
                                            value={ filters.pattern }
                                            options={ padroes }
                                            placeholder="Selecione"
                                            className="dropdown"
                                            showClear
                                            onChange={(event) =>
                                                onFilterChange('pattern', event.value)
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12">
                                    <div className="form-group">
                                        <label>Bairro</label>
                                        <Dropdown
                                            value={ filters.neighborhood }
                                            options={ bairros }
                                            placeholder="Selecione"
                                            className="dropdown"
                                            showClear
                                            onChange={(event) =>
                                                onFilterChange('neighborhood', event.value)
                                            }
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Previsão de lançamento</label>
                                        <Dropdown
                                            value={ filters.previsao_lancamento }
                                            options={ this.previsaoLancamento }
                                            placeholder="Selecione"
                                            className="dropdown"
                                            showClear
                                            optionLabel="label"
                                            optionValue='value'
                                            onChange={(event) =>
                                                onFilterChange('previsao_lancamento', event.value)
                                            }
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Data de cadastro inicial</label>
                                        <DatePicker
                                            locale="pt-BR"
                                            name="data_cadastro_inicial"
                                            className="form-control campo input-default"
                                            selected={ filters.data_cadastro_inicial }
                                            onChange={(date) =>
                                                onFilterChange('data_cadastro_inicial', date)
                                            }
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Selecione"
                                            isClearable
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Data de cadastro final</label>
                                        <DatePicker
                                            locale="pt-BR"
                                            name="data_cadastro_final"
                                            className="form-control campo input-default"
                                            selected={ filters.data_cadastro_final }
                                            onChange={(date) =>
                                                onFilterChange('data_cadastro_final', date)
                                            }
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Selecione"
                                            isClearable
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12">
                                    <div className="form-group">
                                        <label>Incorporadora</label>
                                        <AsyncSelect
                                            isMulti
                                            isSearchable={ !this.state.incorporatorAllSelected }
                                            closeMenuOnSelect={ false }
                                            value={ filters.incorporator }
                                            defaultOptions={ this.getIncorporatorDefaultOptions }
                                            loadOptions={ this.searchIncorporators }
                                            getOptionLabel={(option) => option.text}
                                            getOptionValue={(option) => String(option.id)}
                                            onChange={ this.handleIncorporatorChange }
                                            className="autocomplete"
                                            styles={ asyncSelectCustomStyles }
                                            placeholder="Buscar"
                                            components={ reactSelectIcons }
                                            noOptionsMessage={() => "Digite para buscar..."}
                                            loadingMessage={() => 'Carregando...'}
                                        />
                                    </div>

                                     <div className="form-group">
                                        <label>Atualização</label>
                                        <Dropdown
                                            value={ filters.status_update }
                                            options={ this.atualizacoes }
                                            placeholder="Selecione"
                                            className="dropdown"
                                            showClear
                                            optionLabel="label"
                                            optionValue="value"
                                            onChange={(event) =>
                                                onFilterChange('status_update', event.value)
                                            }
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Usuário</label>
                                        <AsyncSelect
                                            isMulti
                                            closeMenuOnSelect={ false }
                                            value={ filters.user }
                                            loadOptions={ this.searchUsers }
                                            getOptionLabel={(option) => option.text}
                                            getOptionValue={(option) => String(option.id)}
                                            onChange={(value) =>
                                                onFilterChange('user', value)
                                            }
                                            className="autocomplete"
                                            styles={ asyncSelectCustomStyles }
                                            placeholder="Buscar"
                                            components={ reactSelectIcons }
                                            noOptionsMessage={() => "Digite para buscar..."}
                                            loadingMessage={() => 'Carregando...'}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Perfil</label>
                                        <Dropdown
                                            value={ filters.role }
                                            options={ this.perfis }
                                            placeholder="Selecione"
                                            className="dropdown"
                                            showClear
                                            optionLabel="label"
                                            optionValue="value"
                                            onChange={(event) =>
                                                onFilterChange('role', event.value)
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 col-12">
                        <div className="buttons-group">
                            <button
                                type="submit"
                                className="btn btn-success btn-sm btn-block btn-round background-brain border-brain"
                            >
                                <i className="fa fa-search"></i> Filtrar
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger btn-sm btn-block btn-round"
                                onClick={onClear}
                            >
                                <i className="fa fa-times"></i> Limpar
                            </button>
                            <button
                                type="button"
                                className="btn btn-sm btn-primary button-brain btn-round btn-acoes-grupo"
                                onClick={onShowBulkActions}
                                disabled={!selectedBases || selectedBases.length === 0}
                            >
                                Ações em Grupo

                                {selectedBases?.length > 0 && (
                                    <>
                                        {' '}
                                        ({selectedBases.length})
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default PainelFiltros;